import { httpGet, httpPost } from "@eres/rest";
import { I8N } from "@eres/core";
import cfg from "./config";
import { GreenListOTP, GreenListStatus, Lookup, Lookups, VerifyRequest } from "./entities";

export function updateStatus( request: GreenListStatus ) {
	return httpPost( cfg.greenListAPI().endPoint() + `participant/contact`, request );
}

export function getStatus( participantId: any ) {
	return httpGet( cfg.greenListAPI().endPoint() + `participant/contact/detail?participantid=` + participantId );
}

export function generateOTP( request: GreenListOTP ) {
	return httpPost( cfg.greenListAPI().endPoint() + "otp/generate", request );
}

export function verifyOTP( request: VerifyRequest ) {
	return httpPost( cfg.greenListAPI().endPoint() + "otp/verify", request );
}

export function getMemberStatus( email?: any, mobile?: any, participantId?: any ) {
	let params = "";
	if ( email ) params = params + "email=" + email + "&";
	if ( mobile ) params = params + "mobile=" + mobile + "&";
	if ( participantId ) params = params + "participantId=" + participantId;
	return httpGet( cfg.greenListAPI().endPoint() + `participant/contact/search?` + params );
}

export function getLookup( id: Lookups, parent: number = 1, isRemovable: boolean = true ): Promise<Lookup[]> {
	return httpGet( cfg.greenListLookupAPI().endPoint() + `lookup/get?lookupName=${ id }&parentId=${ parent }&isremovable=${ isRemovable }` )
	.then( rsp => {
		let result = rsp.Response;
		if ( result && Array.isArray( result ) ) {
			const lkps = result.map( x => ( {
				en: x.EnglishName,
				ar: x.ArabicName,
				Id: Number( x.Value ),
			} ) );
			return Promise.resolve( lkps );
		} else {
			return Promise.reject( "Invalid Response" );
		}
	} ).catch(ex => {
		return Promise.reject( "Invalid Response" );
	} );
}

export function validateResponse<T>( response: any ): Promise<T> {
	if ( response ) {
		if ( response.Code === 0 || response.Code === "0" ) {
			return Promise.resolve( response.Response );
		} else {
			return Promise.reject( response.Message );
		}
	} else {
		return Promise.reject( "Invalid Response" );
	}
}

export function checkApiRequestResponseError( response: any ): Promise<any> {
	if ( response ) {
		if ( response.Code != null && ( response.Code + "" === "0" || response.Code + "" === "200" ) ) {
			return response;
		} else {
			if ( response.Message != null ) {
				return Promise.reject( response.Message );
			} else {
				return Promise.reject( "Error " + response.Code );
			}
		}
	} else {
		return Promise.reject( "Empty response from Server" );
	}
}

export function checkValidationErrorWithMessage( response: any, key: string = "Errors" ): Promise<any> {
	if ( response ) {
		if ( response.hasOwnProperty( key ) ) {
			let errors = response[ key ];
			if ( errors != null ) {
				if ( Array.isArray( errors ) && errors.length > 0 ) {
					let errorMessage = response.Errors.map( ( error: any ) => {
						return I8N.locale() === "ar" ? error.ErrorMessageAr ?? error.Ar : error.ErrorMessageEn ?? error.En;
					} );
					return Promise.reject( errorMessage );
				}
			}
		}
	}
	return response;
}

export function checkValidationError( apiResposne: any, onNoError: ( response: any ) => void, onValidationError: ( errors: object[], errorMessage: string ) => void ) {
	if ( apiResposne === null ) {
		onValidationError( [], "Null response" );
	} else if ( apiResposne.validationErrorsList !== null && apiResposne.validationErrorsList instanceof Array && apiResposne.validationErrorsList.length > 0 ) {
		let error = apiResposne.validationErrorsList[ 0 ];
		let items = error.items;
		let message = "";
		if ( items && items instanceof Array && items.length > 0 ) {
			for ( const item of items ) {
				let key = item.key;
				let value = item.value;
				if ( key ) {
					if ( I8N.isRTL() ) {
						if ( key === "MessageAr" )
							message += "\n" + value;
					} else if ( key === "MessageEn" )
						message += "\n" + value;
				}
			}
		}
		onValidationError( apiResposne.validationErrorsList, message.trim() );
	} else if ( apiResposne.Errors !== null && apiResposne.Errors instanceof Array && apiResposne.Errors.length > 0 ) {
		let errors = apiResposne.Errors;
		let message = "";
		if ( errors && errors instanceof Array && errors.length > 0 ) {
			for ( const item of errors ) {
				if ( I8N.isRTL() ) {
					message += "\n" + item.Ar;
				} else {
					message += "\n" + item.En;
				}
			}
		}
		onValidationError( apiResposne.validationErrorsList, message.trim() );
	} else if ( apiResposne.response ) {
		let rsp = apiResposne.response;
		onNoError( rsp );
	} else if ( apiResposne.Response ) {
		let rsp = apiResposne.Response;
		onNoError( rsp );
	} else {
		let rsp = apiResposne.Response;
		onNoError( rsp );
	}
}
